import { toast as sonner } from 'sonner';

export const toast = {
    success: (message: string) => sonner.success(message),
    error: (message: string) => sonner.error(message),
    warning: (message: string) => sonner.warning(message),
    info: (message: string) => sonner.info(message)
};
